import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-12 sm:py-16 px-4 relative overflow-hidden" data-id="element-94">
      <div className="absolute inset-0 bg-brand-orange/10 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-95" />

      <div className="max-w-xl mx-auto text-center relative z-10" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-97">
          <CTAButton href="https://italia.kitonline.shop/cart/44562278973575:1" className="w-full mb-5" data-id="element-98">
            💪 SÌ! VOGLIO RIVOLUZIONARE LE MIE LEZIONI ORA
          </CTAButton>

          <div className="flex justify-center gap-3 text-brand-gold font-bold text-xs sm:text-sm" data-id="element-99">
            <span data-id="element-100">⚡ Accesso immediato</span>
            <span data-id="element-101">•</span>
            <span data-id="element-102">🛡️ Garanzia di 14 giorni</span>
          </div>
        </motion.div>
      </div>
    </section>;
}